import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import auth from './reducers/auth/reducer';
import gpsr from './reducers/gpsr/reducer';

const createRootReducer = (history: History) =>
	combineReducers({
		router: connectRouter(history),
		auth,
		gpsr,
	});

export default createRootReducer;
